.controls-input {
  aspect-ratio: unset;
  cursor: pointer;
  height: 0;
  opacity: 0;
  position: absolute;
  width: 0;
}

.controls-input:focus-visible + label {
  outline: 0.125rem dotted var(--color-navy-600);
  outline-offset: 0.125rem;
}

.controls-input:checked + label,
[type="radio"]:checked:hover + label {
  background-color: var(--color-navy-600);
  color: var(--color-uva-white);
  font-weight: var(--semibold);
}

.controls-input:disabled + label,
.controls-input:disabled:hover + label {
  background-color: var(--color-grey-400);
  color: var(--color-grey-700);
  cursor: not-allowed;
}

.controls-input:disabled:checked + label {
  background-color: var(--color-grey-500);
  color: var(--color-grey-900);
  font-weight: var(--semibold);
}

.controls-input:hover + label {
  background-color: var(--color-grey-300);
  color: var(--color-uva-black);
}

.controls-button {
  align-items: center;
  background-color: var(--color-uva-white);
  border: 1px solid transparent;
  border-radius: 0.25rem;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  font-size: var(--font-size-default);
  height: 2.25rem;
  justify-content: center;
  min-width: 2.25rem;
  padding: 0.5rem;
  position: relative;
  user-select: none;
  white-space: nowrap;
}

.controls-button--squared {
  width: 2.25rem;
}

.controls-button::after {
  content: "";
  min-height: 2.625rem;
  min-width: 2.625rem;
  position: absolute;
  width: 100%;
}

.controls-button--with-prefix {
  height: auto;
  padding: 0.125rem 0.5rem;
  width: auto;
}

.controls-button--with-icon {
  gap: 0.5rem;
}

.controls-button__wrapper {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.controls-button__prefix {
  color: var(--color-uva-700);
  font-size: var(--font-size-text-non-essential);
}

.controls-button__tooltip {
  background-color: var(--color-uva-white);
  box-shadow: 0 0 0.25rem 0 rgba(0 0 0 / 25%);
  color: var(--color-grey-700);
  display: none;
  font-size: var(--font-size-text-non-essential);
  font-style: italic;
  font-weight: normal;
  padding: 0.5rem 1rem;
  position: absolute;
  text-align: center;
  top: calc(100% + 0.5rem);
  z-index: 1;
}

.controls-button__tooltip--left {
  left: 0rem;
}

.controls-button__tooltip--center {
  left: 50%;
  transform: translateX(-50%);
}

.controls-button__tooltip--right {
  right: 0rem;
}

.controls-button__tooltip::before {
  border-color: transparent transparent var(--color-grey-400) transparent;
  border-style: solid;
  border-width: 0.5rem;
  bottom: calc(100% + 0.125rem);
  content: "";
  filter: blur(0.125rem);
  position: absolute;
  z-index: -1;
}

.controls-button__tooltip::after {
  border-color: transparent transparent var(--color-uva-white) transparent;
  border-style: solid;
  border-width: 0.5rem;
  bottom: 100%;
  content: "";
  position: absolute;
}

.controls-button:hover .controls-button__tooltip,
.controls-input:focus-visible + label .controls-button__tooltip {
  display: block;
}

.controls-button__tooltip--left::before,
.controls-button__tooltip--left::after {
  left: 0.5rem;
}

.controls-button__tooltip--center::before,
.controls-button__tooltip--center::after {
  left: 50%;
  transform: translateX(-50%);
}

.controls-button__tooltip--right::before,
.controls-button__tooltip--right::after {
  right: 0.5rem;
}

.controls-button--checked span.periods__item,
.controls-button--checked [data-period-item] {
  border: 1px solid var(--color-uva-white) !important;
}
